import clsx from 'clsx';
import type { ReactNode } from 'react';
import { BrandColor } from '../../types/brand-color';
import { Text } from '../Text/Text';
import styles from './ButtonStyle.module.scss';

export type ButtonStyleProps = {
  variant?: 'primary' | 'secondary';
  color?: BrandColor;
  children: ReactNode;
  isOutlined?: boolean;
};

export const ButtonStyle = ({
  variant = 'primary',
  color = 'white',
  isOutlined,
  children,
}: ButtonStyleProps) => {
  const classes = clsx(styles.base, styles[variant], {
    [styles.outlined]: isOutlined,
  });

  return (
    <span className={classes}>
      <Text
        className={styles.text}
        color={color}
        variant="inline"
        align="center"
      >
        {children}
      </Text>
    </span>
  );
};
